import { useNavigate } from 'react-router-dom';
import { Lock, Rocket } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function ComingSoonPage({ title = 'Feature', description }) {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto text-center py-20" data-testid="coming-soon-page">
      <div className="w-16 h-16 mx-auto mb-6 rounded-2xl flex items-center justify-center"
        style={{ background: 'rgba(13,148,136,0.08)' }}>
        <Rocket className="w-8 h-8" style={{ color: '#0D9488' }} />
      </div>
      <h1 className="text-2xl font-extrabold mb-2" style={{ color: 'var(--t-text-heading)' }}>
        {title}
      </h1>
      <p className="text-sm mb-2" style={{ color: 'var(--t-text-muted)' }}>
        Coming in v2.0
      </p>
      <p className="text-xs mb-8 max-w-sm mx-auto" style={{ color: 'var(--t-text-muted)' }}>
        {description || 'This feature is being built and will be available in the next version. Focus on completing your Career Intelligence first!'}
      </p>
      <Button onClick={() => navigate('/career-intel')} data-testid="go-to-ci-btn"
        className="h-10 px-6 text-sm font-semibold rounded-lg"
        style={{ background: '#0D9488', color: '#fff' }}>
        Go to Career Intelligence
      </Button>
    </div>
  );
}
